var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-12 col-sm-6"},[_vm._m(0),_c('OrderContent',{attrs:{"dropDownObj":_vm.dropDownObj}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-title-area-sty"},[_c('div',{staticClass:"order-main-title-sty"},[_c('h3',[_vm._v("預約服務")])])])
}]

export { render, staticRenderFns }